export const AthenaTabs = Object.freeze({
  ACTIVE: {
    text: 'Active',
  },
  NOT_ACTIVE: {
    text: 'Not Active',
  },
  ALL: {
    text: 'All',
  },
});

export const DefaultTabInfo = Object.freeze({
  ACTIVE: {
    text: AthenaTabs.ACTIVE.text,
    count: 0,
  },
  NOT_ACTIVE: {
    text: AthenaTabs.NOT_ACTIVE.text,
    count: 0,
  },
  ALL: {
    text: AthenaTabs.ALL.text,
    count: 0,
  },
});

export const TableHeaders = [
  { column: 'practiceId', label: 'Practice ID', width: '17%', sortBy: 'text' },
  { column: 'athenaPatientId', label: 'Athena Patient ID', width: '17%', sortBy: 'text' },
  { column: 'department', label: 'Department', width: '14%', sortBy: 'text' },
  { column: 'createdAt', label: 'Created', width: '14%', sortBy: 'value' },
  { column: 'createdBy', label: 'Created By', width: '17%', sortBy: 'value' },
  { column: 'actions', label: 'Actions', width: '21%' },
];
